export const defaultImage = '/assets/default.png';

// Shared cadence for Live Preview / continuous-edit coalescing. Continuous
// inputs (color pickers, sliders) commit their command at most once per this
// window (see useDebouncedCommit), and the Live Preview publisher throttles
// pushes to the same interval — so a drag produces one undo entry and one push
// per window instead of dozens.
export const LIVE_PREVIEW_DEBOUNCE_MS = 200;

export const apiBindings: {api: string, images: string} = {
    api: "https://editor-api.xp3games.com/api/",
    images: "https://riftadminfunctionsdev.blob.core.windows.net/image-bindings/"
}